<kodit-list [items]="cenovnicList" [listConfig]="listConfig"></kodit-list>
